"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guardianshipFactory = void 0;
const Factory = require("factory.ts");
const guardianship_persona_factory_1 = require("./guardianship-persona.factory");
const guardianship_user_factory_1 = require("./guardianship-user.factory");
const persona = guardianship_persona_factory_1.guardianshipPersonaFactory.build();
const user = guardianship_user_factory_1.guardianshipUserFactory.build();
exports.guardianshipFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    access: 'manager',
    email_address: 'test@example.com',
    initiator: 'myse',
    initiator_user_id: 1,
    persona,
    persona_id: persona.id,
    user,
    user_id: user.id
});
